/**
 * Use this to replace the DOM element you want to mount a Svelte component to, with the component.
 * This allows you to avoid leaving the custom tag in the DOM.
 *
 * @param {ISvelteCtor} Component
 * @param {Object} options
 * @example:
 * function init() {
 *     mountReplace(MySvelteComponent, {
 *         'target': document.querySelector('main'),
 *             'data': {
 *             'name': 'world'
 *         }
 *     });
 * }
 * @return {SvelteComponent}
 */
export default function (Component, options) {
    const frag = document.createDocumentFragment();
    const component = new Component({ ...options, target: frag });

    options.target.parentNode.replaceChild(frag, options.target);

    return component;
}
